// extracted by mini-css-extract-plugin
export var active = "SkillCoursePlanCard-module--active--73f53";
export var lmsScrollbar = "SkillCoursePlanCard-module--lms-scrollbar--433ed";
export var planCard = "SkillCoursePlanCard-module--planCard--f0f6c";
export var price = "SkillCoursePlanCard-module--price--6257f";
export var tickIcon = "SkillCoursePlanCard-module--tickIcon--38ec7";
export var validity = "SkillCoursePlanCard-module--validity--b5640";